module.exports = new __parcel__URL__("NIST_Methane_Intercomparisons_card.74855293.png").toString();